import classNames from 'classnames';
import React, { useState } from 'react';
import { NameEmailAvatar } from '../../../../../ui/components/Common';
import { ChevronRight } from '../../../../../ui/icons/icons';
import { ContextBasedGeneratorJob, QuestionGeneratorJob, TopicBasedGeneratorJob } from '../../../../../utils/types/content_manager_types';
import { TriageRow } from '../triage_row/triage_row';
import styles from './document.module.css';
import { DocumentDetails } from './document_details/document_details';

export type DocumentProps = {
  job: TopicBasedGeneratorJob | ContextBasedGeneratorJob,
  updateJob: (newJobData: QuestionGeneratorJob) => void;
}

export const Document = ({
  job,
  updateJob,
}: DocumentProps) => {
  const [open, setOpen] = useState(false);
  const hasDetails =
    ('transcript' in job && job.transcript && job.transcript.length > 0) ||
    (job.topic && job.topic.length > 0) ||
    Boolean(job.questions?.length);

  const uploaderName =
    [job.user?.firstName, job.user?.lastName].filter(Boolean).join(' ') ||
    'Unknown user';
  const status = job.status.split('.').join('').trim();
  const statusKey = status.toLowerCase();
  const statusClassName = statusKey.includes('completed')
    ? styles.statusCompleted
    : statusKey.includes('queue')
      ? styles.statusQueue
      : statusKey.includes('error')
        ? styles.statusError
        : styles.statusNeutral;

  const toggleDetails = () => {
    if (hasDetails) {
      setOpen(!open);
    }
  };

  return (
    <>
      <div
          className={classNames(styles.document, {
            [styles.open]: open,
          })}
      >
        <TriageRow>
          <div className={styles.titleContainer}>
            <div className={styles.toggleBtnContainer}>
              <button
                  className={styles.toggleBtn}
                  onClick={toggleDetails}
                  disabled={!hasDetails}
                  aria-label={
                    open ? 'Collapse document details' : 'Expand document details'
                  }
              >
                <ChevronRight className='h-4 w-4' />
              </button>
            </div>
            <div className={styles.contentContainer}>
              <p className={styles.title}>{ job.title }</p>
              <div className={styles.metaLine}>
                <span>{ job.generationType || 'context' }</span>
                { 'filename' in job && job.filename && (
                  <span>{ job.filename }</span>
                ) }
                <span>{ job.questions?.length || 0 } questions</span>
              </div>
            </div>
          </div>
          <>
            <p className={styles.uploadDate}>
              { job.creationDateTime !== 0
                ? new Date(job.creationDateTime * 1000).toLocaleString()
                : 'Unavailable' }
            </p>
          </>
          <>
            <span className={classNames(styles.statusChip, statusClassName)}>
              { status }
            </span>
          </>
          <>
            <NameEmailAvatar
                name={uploaderName}
                email={job.user?.email}
                avatar={undefined}
                avatarWidth='30px'
                avatarHeight='30px'
                nameFontSize='13px'
                emailFontSize='11px'
            />
          </>
        </TriageRow>
      </div>
      { open && <DocumentDetails job={job} updateJob={updateJob} /> }
    </>
  );
};
